(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["astari-reviews"] && !Shopify.designMode) return;
  try {
    
class AstariReviewsCarousel {
  constructor(container) {
    this.container = container;
    this.inner = container.querySelector('.astari-reviews__carousel-inner');
    this.leftArrow = container.querySelector('.astari-reviews__arrow--left');
    this.rightArrow = container.querySelector('.astari-reviews__arrow--right');
    this.reviews = container.querySelectorAll('.astari-reviews__review');
    this.isMobile = window.innerWidth <= 989;
    this.visibleReviews = this.isMobile ? 1 : 3;
    this.gap = this.isMobile ? 8 : 12; /* Match CSS gap (0.5rem = 8px, 0.75rem = 12px) */
    this.reviewWidth = this.reviews[0] ? this.reviews[0].offsetWidth + this.gap : 0;
    this.currentIndex = 0;
    this.touchStartX = 0;
    this.touchEndX = 0;
    this.init();
  }
  init() {
    this.leftArrow.addEventListener('click', () => this.scrollLeft());
    this.rightArrow.addEventListener('click', () => this.scrollRight());
    window.addEventListener('resize', () => this.handleResize());
    this.inner.addEventListener('touchstart', (e) => {
      this.touchStartX = e.changedTouches[0].screenX;
    });
    this.inner.addEventListener('touchend', (e) => {
      this.touchEndX = e.changedTouches[0].screenX;
      this.handleSwipe();
    });
    this.updateCarousel();
  }
  handleSwipe() {
    const swipeDistance = this.touchStartX - this.touchEndX;
    const minSwipeDistance = 50;
    if (swipeDistance > minSwipeDistance && this.currentIndex < this.reviews.length - this.visibleReviews) {
      this.currentIndex++;
      this.updateCarousel();
    } else if (swipeDistance < -minSwipeDistance && this.currentIndex > 0) {
      this.currentIndex--;
      this.updateCarousel();
    }
  }
  handleResize() {
    const wasMobile = this.isMobile;
    this.isMobile = window.innerWidth <= 989;
    this.visibleReviews = this.isMobile ? 1 : 3;
    this.gap = this.isMobile ? 8 : 12;
    this.reviewWidth = this.reviews[0] ? this.reviews[0].offsetWidth + this.gap : 0;
    if (wasMobile !== this.isMobile) {
      this.currentIndex = 0;
      this.updateCarousel();
    }
  }
  scrollLeft() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
      this.updateCarousel();
    }
  }
  scrollRight() {
    if (this.currentIndex < this.reviews.length - this.visibleReviews) {
      this.currentIndex++;
      this.updateCarousel();
    }
  }
  updateCarousel() {
    this.inner.style.transform = `translateX(-${this.currentIndex * this.reviewWidth}px)`;
    this.leftArrow.style.display = this.reviews.length > this.visibleReviews ? 'flex' : 'none';
    this.rightArrow.style.display = this.reviews.length > this.visibleReviews ? 'flex' : 'none';
    this.leftArrow.disabled = this.currentIndex === 0;
    this.rightArrow.disabled = this.currentIndex >= this.reviews.length - this.visibleReviews;
  }
}
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.astari-reviews__carousel').forEach((container) => {
    new AstariReviewsCarousel(container);
  });
});
document.addEventListener('shopify:section:load', (e) => {
  const container = e.target.querySelector('.astari-reviews__carousel');
  if (container) new AstariReviewsCarousel(container);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
